import { GetRegistrationInfo } from '../generated-types/GetRegistrationInfo';
import { RegistrationVariantProps } from '../interfaces/registrationVariant';
import { registrationVariants } from '../registration-variants';
import { replaceInterpolatedVariables } from './string-utils';

export const getRegistrationVariantFromQuery = (data?: GetRegistrationInfo): RegistrationVariantProps => {
  // It's possible the variant might be expired, or have a typo or something.
  // Fall back to the default if no matching variant exists.
  let variant = registrationVariants.primary;

  if (data) {
    if (data.registrationFormData?.marketplace_app?.name) {
      variant = registrationVariants.marketplace;
    } else if (data.registrationFormData?.oauth_app?.name) {
      if (data.registrationFormData.oauth_app.is_internal) {
        variant = registrationVariants.community;
      } else {
        variant = registrationVariants.oauth_app;
      }
    } else if (data.registrationFormData?.team) {
      variant = registrationVariants.team;
    }
  }

  return replaceInterpolatedVariables(data || {}, variant);
};
